import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { Store } from '@ngrx/store';
import { CarMake } from 'src/app/public/car/models/car-make.model';
import { CarModel } from 'src/app/public/car/models/car-model.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { CarEngine } from 'src/app/public/car/models/car-engine.model';
import { CarFeature } from 'src/app/public/car/models/car-feature.model';


@Component({
    selector: 'app-carref-models',
    templateUrl: './carref-models.component.html',
    styleUrl: './carref-models.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarrefModelsComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() makes: CarMake[] = [];
  @Input() models: CarModel[] = [];

  @Input() engines: CarEngine[] = [];
  @Input() features: CarFeature[] = [];

  newItem: CarModel = new CarModel('', '');
  editedItem: CarModel = new CarModel('', '');

  newCarVersion: string = '';
  updatedCarVersions: string[] = [];

  displayedColumns: string[] = ['id', 'makeName', 'name', 'versions', 'engineNames','featureNames', 'lastUpdated', 'actions'];
  dataSource = new MatTableDataSource<CarModel>(this.models);

  @ViewChild(MatPaginator) paginator! : MatPaginator;
  @ViewChild(MatSort) sort! : MatSort;

  editingItemId: number = 0;
  editingItem: boolean = false;

  constructor(
    private store: Store){
  
  }

  ngOnInit(){
    this.store.dispatch (CarRefActions.modelsFetchSubmit({}));
    this.store.dispatch (CarRefActions.featuresFetchSubmit({}));
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['models']){
      this.dataSource.data = changes['models'].currentValue;
      
    }
    if(changes['features']){
      this.dataSource.data = changes['features'].currentValue;
    }
  }

  applyFilter(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }
  
  addNewRow(){
    //const newManuf = new CarModel('','',false);
    if(! (this.editingItem  && this.editingItemId === 0)){
      this.editedItem = new CarModel('','');
      this.dataSource.data = [...this.dataSource.data, new CarModel('','')];
      this.editingItemId = 0;
      this.editingItem = true;
    }
    
  }

  editItem(id: number){
    this.editingItemId = id;
    this.editingItem = true;
    //console.log(this.models.find((manuf: CarModel) => manuf.id === id));
    this.editedItem = Object.assign({}, this.editedItem, this.models.find((item: CarModel) => item.id === id) );
    this.updatedCarVersions = [...this.editedItem.versions];
    //console.log(this.editedItem);
  }

  saveItem(id: number){
    this.editingItemId = 0;
    this.editingItem = false;
    //console.log(this.editedItem);
    //console.log(this.models.find((manuf: CarModel) => manuf.id === id));
    this.editedItem = Object.assign({}, this.models.find((md: CarModel) => md.id === id), this.editedItem);

    this.editedItem.versions = [...this.updatedCarVersions];
    
    console.log(this.editedItem);
  
    if(id===0){
      this.store.dispatch (CarRefActions.modelNewSubmit({model: this.editedItem }));
    } else{
      this.editedItem.id=id;
      console.log(this.editedItem);
      this.store.dispatch (CarRefActions.modelUpdateSubmit({model: this.editedItem }));
    }
    
  }

  deleteItem(id: number){
    console.log(id)
    if(id ===0 || this.editingItem){
      this.dataSource.data = this.dataSource.data.filter(manuf => manuf.id !== 0);
      this.editingItem = false;
      this.editingItemId === 0
    }
      else{
        this.store.dispatch (CarRefActions.modelDeleteSubmit({modelId: id }));
    }
    
  }

  editedItemIsValid(): boolean{
    return this.editedItem.makeId > 0 && this.editedItem.name.length > 0;
   }

  dateTimeFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

}
